import colors from '../colors';
export default {
  container: {},
  scroller: {},
  tabContainer: {},
  tabButton: {
    "default": {
      color: colors.blueyGrey,
      fontSize: '16px',
      fontWeight: 500,
      fontStyle: 'normal',
      fontStretch: 'normal',
      lineHeight: 1.63
    },
    selected: {
      color: colors.periwinkle
    },
    disabled: {
      color: colors.cloudyBlue,
      cursor: 'not-allowed'
    }
  },
  tabButtonWrapper: {},
  indicator: {
    backgroundColor: colors.periwinkle
  }
};